import { h } from 'preact';
import { LocaleActions } from 'actions'
import _I18n from 'lib/i18n'

function I18n(props) {
    return LocaleActions.translate(props.children) || ""
}
I18n.t=(key)=>(
    LocaleActions.translate(key)
)
I18n.translations = _I18n.translations
export default I18n


// WEBPACK FOOTER //
// ./components/elements/I18n/index.js